import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { partnerApi } from '../lib/api';
import { useAuth } from '../hooks/useAuth';

interface LaunchDarklyProviderProps {
  children: React.ReactNode;
}

export const LaunchDarklyProvider: React.FC<LaunchDarklyProviderProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  // Fetch partner data to get partner ID
  const { data: partner } = useQuery({
    queryKey: ['partner'],
    queryFn: () => partnerApi.getPartner(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: isAuthenticated,
  });

  if (!partner || !isAuthenticated) {
    return <>{children}</>;
  }
  const partnerId = partner?.id || '';
  const key = partnerId || 'anonymous';

  return (
    <LDProvider
      clientSideID={import.meta.env.VITE_LAUNCHDARKLY_CLIENT_SIDE_ID}
      context={{
        kind: 'user',
        key,
        custom: {
          partnerId,
        },
      }}
      options={{
        streaming: true,
      }}
      timeout={2}
      reactOptions={{
        useCamelCaseFlagKeys: false,
        sendEventsOnFlagRead: true,
      }}>
      {children}
    </LDProvider>
  );
};
